<div class="page-container">
    <h1>Clients</h1>
    <div class="container">
        <div style="display: flex; justify-content: space-between;">
            <mat-form-field class="form-field">
                <mat-label>Search</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Type something..." #input>
            </mat-form-field>
            <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
            <button mat-flat-button color="primary" (click)="addClient()"
            >Add New</button>
            </div>
            
        </div>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource"
                   class="mat-elevation-z8 table"
                   matSort>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> Company Name </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="20"> {{element?.name}} </td>
                    
                </ng-container>

                <ng-container matColumnDef="contactName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> Contact Name </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="20"> {{element?.contactName}} </td>
                </ng-container>

                <ng-container matColumnDef="address">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> Address </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="20"> {{element?.address}} </td>
                </ng-container>

                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> Email </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="20"> {{element?.email}} </td>
                </ng-container>

                <ng-container matColumnDef="phone">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> Phone </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="20"> {{element?.phone}} </td>
                </ng-container>

                <ng-container matColumnDef="viewClient">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> View</th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="20"> 
                        <button mat-button mat-icon-button onclick="this.blur()" (click)="viewClient(element)">
                            <mat-icon>arrow_forward</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="update">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> Update</th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="20"> 
                        <button mat-button mat-icon-button onclick="this.blur()" (click)="editCompanyName(element)" >
                            <mat-icon>
                                edit
                            </mat-icon>
                        </button>
                    </td>
                </ng-container>

                <ng-container matColumnDef="dalete">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> Delete </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="20"> 
                        <button mat-button mat-icon-button onclick="this.blur()" (click)="deleteCompany(element)" >
                            <mat-icon>
                                delete
                            </mat-icon>
                        </button>
                    </td>
                </ng-container>
                <!-- <ng-container matColumnDef="createdAt">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> Date </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="20"> {{element?.createdAt | date : 'dd.MM.yy
                        HH:mm:ss'}} </td>
                </ng-container>
                <ng-container matColumnDef="user">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="15"> User </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="20"> {{element?.user?.name ?
                        element?.user?.name : 'System'}} </td>
                </ng-container>

                <ng-container matColumnDef="message">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="60"> Message </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="60"> {{element?.message}} </td>
                </ng-container> -->



                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    [ngClass]="row.isError ? 'error-row' : ''"
                   ></tr>

                <!-- Row shown when there is no matching data.   [@rowsAnimation]=""-->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
                </tr>
            </table>
            <div class="loading-wrapper-transparent" *ngIf="loading">
                <mat-spinner diameter="30"></mat-spinner>
            </div>
        </div>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="pageSize"></mat-paginator>

    </div>
   
    <!-- <div class="box">
        <div class="title">Company</div>
        <div class="message" *ngIf="messages['company']">{{ messages['company'] }}</div>
        <div class="form">
            <div class="field">
                <input type="checkbox" [(ngModel)]="update['company']" (change)="create['company'] = {}; companySearch.value = null">Update
            </div>
            <div class="field">
                <select [(ngModel)]="create['company']" [disabled]="!update['company']">
                    <option value="">----</option>
                    <option *ngFor="let i of items['company'] | bofilter: { k: 'name', v: companySearch.value }" [ngValue]="i">{{ i.name }}</option>
                </select>
                Search: <input ngModel #companySearch [disabled]="!update['company']" (ngModelChange)="create['company']={}">
            </div>
            <div class="field">
                <label>Name</label>
                <input type="text" [(ngModel)]="create['company'].name">
            </div>
            <div class="field">
                <button (click)="createOrUpdate('company')">{{ update['company'] ? 'Update' : 'Create' }}</button>
                <div *ngIf="update['company']">
                    <button class="delete" (click)="delete('company')">Delete</button>
                    <input type="checkbox" [(ngModel)]="create['company'].deleteRelatedGateways">Delete related gateways
                    <input type="checkbox" [(ngModel)]="create['company'].deleteRelatedZones">Delete related zones
                    <input type="checkbox" [(ngModel)]="create['company'].deleteRelatedSensors">Delete related sensors
                </div>
            </div>
        </div>
    </div> -->

   
</div>